import { init } from '@sentry/react';

import { DOMReady } from './utils';
import initPages from './pages';
import initGlobal from './pages/global';

const initSentry = (sentryDSN: string): void => {
  init({
    dsn: sentryDSN,
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extensions:\/\//i,
      /embed\.tawk\.to/i,
      /cdn\.tawk\.to/i
    ],
    ignoreErrors: [
      /tawk/i
    ],
    tracesSampleRate: 0.1
  });
};

DOMReady(() => {
  // eslint-disable-next-line no-underscore-dangle
  const config = window.__config__;

  if (config.sentryDSN) {
    initSentry(config.sentryDSN);
  }

  initPages(config);
  initGlobal(config);
});
